import { render, staticRenderFns } from "./history_list.vue?vue&type=template&id=d6957690&scoped=true&"
import script from "./history_list.vue?vue&type=script&lang=js&"
export * from "./history_list.vue?vue&type=script&lang=js&"
import style0 from "./history_list.vue?vue&type=style&index=0&id=d6957690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6957690",
  null
  
)

export default component.exports